// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3zDcK","description":"PatientConsentPreview_description__FTCBI"};